<template>
  <div class="top-content">
    <div class="left">
      <div class="datetime-info">
        <p>{{ currentDate }} {{ currentDay }}</p>
      </div>
    </div>
    <div class="title">大兴生物医药产业基地智慧化危险废物管理平台</div>
    <div class="right">
      <div class="weather-info">
        {{ weather.temperature }} ℃ {{ weather.weather }}
        {{ weather.province + " - " + weather.city }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      currentDate: "",
      currentDay: "",
      timer: null,
      weather: {},
    };
  },
  mounted() {
    this.getWeather();
    this.updateDateTime();
    setInterval(this.updateDateTime, 1000);
    this.timer = setInterval(this.updateDateTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getWeather() {
      const url = this.$api.cockpit.getWeather;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          console.log(res.data.data);
          this.weather = res.data.data.lives[0];
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });

      // this.$axios.get(url, null, false).then((res) => {
      //   console.log(res);
      // });
    },
    updateDateTime() {
      const now = new Date();
      this.currentDate = `${now.getFullYear()}.${this.addLeadingZero(
        now.getMonth() + 1
      )}.${this.addLeadingZero(now.getDate())} ${this.addLeadingZero(
        now.getHours()
      )}:${this.addLeadingZero(now.getMinutes())}:${this.addLeadingZero(
        now.getSeconds()
      )}`;
      this.currentDay = this.getDayOfWeek(now.getDay());
    },
    addLeadingZero(number) {
      return number < 10 ? "0" + number : number;
    },
    getDayOfWeek(day) {
      const daysOfWeek = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      return daysOfWeek[day];
    },
  },
};
</script>

<style lang="scss" scoped>
.top-content {
  display: flex;

  .left {
    width: 30%;
    position: relative;

    .datetime-info {
      position: absolute;
      left: 50px;
      top: 30px;
    }
  }

  .right {
    width: 30%;

    position: relative;

    .weather-info {
      position: absolute;
      right: 50px;
      top: 30px;
    }
  }

  .title {
    flex: 1;
    color: #fff;
    text-align: center;
    line-height: 60px;
    font-size: 24px;
    white-space: nowrap;
  }
}
</style>